import { tcouponFrontend } from 'src/shared/frontendTypes/coupon'

export const checkCoupon = async (couponCode: string, shopId: number): Promise<tcouponFrontend | null> => {
  try {
    const response = await fetch(`/api/coupon/${couponCode}`)
    if (response.ok) {
      const couponData: tcouponFrontend = await response.json()

      // 1) Coupon aktiv?
      if (!couponData.active) {
        throw new Error('Coupon ist nicht aktiv.')
      }

      // 2) Ist er abgelaufen?
      if (couponData.expirationDate && new Date() > new Date(couponData.expirationDate)) {
        throw new Error('Coupon ist abgelaufen.')
      }

      // 3) Ist er einem Shop zugeordnet und für diesen Shop gültig?
      if (!Array.isArray(couponData.shops) || couponData.shops.length === 0) {
        throw new Error('Coupon ist keinem Shop zugeordnet.')
      }

      if (!couponData.shops.includes(shopId)) {
        throw new Error('Coupon ist für diesen Shop nicht gültig.')
      }

      // 4) Gültigkeit nach Einlösungen
      // Prüfe, wie oft der Coupon bereits eingelöst wurde
      const usageCount = couponData.coupon?.length ?? 0  // "coupon" Array enthält Einlösvorgänge

      if (!couponData.isMultiUse) {
        // isMultiUse === false => Nur einmal zulässig
        // => usageCount muss 0 sein
        if (usageCount > 0) {
          throw new Error('Coupon wurde bereits eingelöst und ist nicht mehrfach nutzbar.')
        }
      } else {
        // isMultiUse === true => mehrfach zulässig, aber usageLimit beachten
        if (couponData.usageLimit !== null && couponData.usageLimit !== undefined && usageCount >= couponData.usageLimit) {
          throw new Error(`Coupon ist bereits ${usageCount}x eingelöst. usageLimit: ${couponData.usageLimit} erreicht.`)
        }
      }

      // Weitere Prüfungen hier hinzufügen, falls erforderlich
      // ...

      return couponData
    } else {
      const errorText = await response.text()
      throw new Error(errorText)
    }
  } catch (error) {
    console.error('Error checking coupon:', error)
    throw error // Fehler werfen, um ihn im handleApplyCoupon zu behandeln
  }
}
